import * as reportTypes from "../../types/admin/reportTypes";

export const checkinReportDownloadReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case reportTypes.CHECK_IN_DOWNLOAD_REPORT_REQUEST:
      return {
        ...state,
        checkinReportDownloadLoadings: true,
      };
    case reportTypes.CHECK_IN_DOWNLOAD_REPORT_SUCCESS:
      return {
        ...state,
        checkinReportDownloadLoadings: false,
        checkinReportDownloadInfo: payload,
        checkinReportDownloadErrors: "",
      };
    case reportTypes.CHECK_IN_DOWNLOAD_REPORT_FAIL:
      return {
        ...state,
        checkinReportDownloadLoadings: false,
        checkinReportDownloadErrors: payload,
        checkinReportDownloadInfo: [],
      };
    default:
      return state;
  }
};

export const getDownloadedReportsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case reportTypes.GET_DOWNLOADED_REPORTS_REQUEST:
      return {
        ...state,
        getDownloadedReportsLoadings: true,
      };
    case reportTypes.GET_DOWNLOADED_REPORTS_SUCCESS:
      return {
        ...state,
        getDownloadedReportsLoadings: false,
        getDownloadedReportsInfo: payload,
        getDownloadedReportsErrors: "",
      };
    case reportTypes.GET_DOWNLOADED_REPORTS_FAIL:
      return {
        ...state,
        getDownloadedReportsLoadings: false,
        getDownloadedReportsErrors: payload,
        getDownloadedReportsInfo: [],
      };
    default:
      return state;
  }
};

export const updateDownloadHistoryReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case reportTypes.UPDATE_DOWNLOAD_HISTORY_REQUEST:
      return {
        ...state,
        updateDownloadHistoryLoadings: true,
      };
    case reportTypes.UPDATE_DOWNLOAD_HISTORY_SUCCESS:
      return {
        ...state,
        updateDownloadHistoryLoadings: false,
        updateDownloadHistoryInfo: payload,
        updateDownloadHistoryErrors: "",
      };
    case reportTypes.UPDATE_DOWNLOAD_HISTORY_FAIL:
      return {
        ...state,
        updateDownloadHistoryLoadings: false,
        updateDownloadHistoryErrors: payload,
        updateDownloadHistoryInfo: [],
      };
    default:
      return state;
  }
};
